<template>
  <div class="hero-section">
    <!-- YouTube Video Background -->
    <iframe
      v-if="youtubeVideoId"
      class="video-background"
      :src="`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&mute=1&loop=1&playlist=${youtubeVideoId}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1`"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen
    ></iframe>

    <!-- Fallback Background -->
    <div v-else class="fallback-background"></div>

    <!-- Dark Overlay -->
    <div class="overlay"></div>

    <!-- Hero Section Content -->
    <v-container class="hero-container">
      <v-row class="hero-row" align="center" justify="center">
        <v-col cols="12" class="hero-col">
          <!-- Subtitle -->
          <p class="hero-subtitle">AI 2030: Accelerating Intelligent Futures</p>

          <!-- Main Title -->
          <h1 class="hero-title">
            The Future is EDUCATION<br />
            Korea Educational Technology & Contents Fair 2026
          </h1>

          <!-- Event Date and Location -->
          <p class="hero-event-info">
            January 21 (Wed) ~ 23 (Fri), 2026, COEX, Seoul
          </p>

          <!-- CTA Buttons -->
          <v-row justify="center" no-gutters>
            <v-col cols="auto" class="mx-auto pa-0 mb-10">
              <gradient-button
                style="background-color: orange"
                variant="bordered-white"
                size="large"
                to="/form-fill"
              >
                Бүртгүүлэx
              </gradient-button>
            </v-col>
          </v-row>

          <!-- Statistics Section -->
          <div class="stats-section">
            <div class="stat-box">
              <h2 class="stat-value">10,000+</h2>
              <p class="stat-label">Attendees</p>
            </div>
            <div class="stat-box">
              <h2 class="stat-value">250+</h2>
              <p class="stat-label">Speakers</p>
            </div>
            <div class="stat-box">
              <h2 class="stat-value">200+</h2>
              <p class="stat-label">Exhibitors</p>
            </div>
            <div class="stat-box">
              <h2 class="stat-value">300+</h2>
              <p class="stat-label">Media</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import GradientButton from "./GradientButton.vue";

export default {
  name: "HeroSection",
  components: {
    GradientButton,
  },
  data() {
    return {
      youtubeVideoId: "9s6cfD-TfBQ",
    };
  },
};
</script>

<style scoped>
/* === MAIN CONTAINER === */
.hero-section {
  position: relative;
  width: 100%;
  min-height: 745px;
  overflow: hidden;
  background-color: #000;
}

/* === VIDEO BACKGROUND === */
.video-background {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 56.25vw; /* 16:9 aspect ratio */
  min-height: 100vh;
  min-width: 177.77vh; /* 16:9 aspect ratio */
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 0;
}

/* === FALLBACK BACKGROUND === */
.fallback-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  z-index: 0;
}

/* === DARK OVERLAY === */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.6) 50%,
    rgba(0, 0, 0, 0.75) 100%
  );
  z-index: 1;
}

/* === HERO SECTION === */
.hero-container {
  position: relative;
  z-index: 2;
  max-width: 1400px;
  padding-top: 120px;
  padding-bottom: 60px;
}

.hero-row {
  min-height: auto;
}

.hero-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

/* Hero Subtitle */
.hero-subtitle {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: white;
  opacity: 0.9;
  margin-bottom: 20px;
}

/* Hero Main Title */
.hero-title {
  font-size: 56px;
  font-weight: 700;
  line-height: 1.2;
  color: white;
  text-shadow: 2px 4px 12px rgba(0, 0, 0, 0.6);
  margin-bottom: 24px;
  max-width: 850px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Event Info */
.hero-event-info {
  font-size: 16px;
  font-weight: 400;
  color: white;
  opacity: 0.9;
  margin-bottom: 40px;
}

/* Hero Buttons */
.hero-buttons {
  margin-bottom: 70px;
}

/* === STATISTICS SECTION === */
.stats-section {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  flex-wrap: wrap;
  max-width: 900px;
  margin: 0 auto;
}

.stat-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
}

.stat-value {
  font-size: 42px;
  font-weight: 700;
  color: white;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
  margin-bottom: 6px;
  line-height: 1;
}

.stat-label {
  font-size: 14px;
  font-weight: 400;
  color: white;
  opacity: 0.85;
  margin: 0;
}

/* === RESPONSIVE DESIGN === */

/* Large Tablets */
@media (max-width: 1264px) {
  .hero-section {
    min-height: 650px;
  }

  .hero-title {
    font-size: 48px;
  }

  .stats-section {
    gap: 40px;
  }
}

/* Tablets */
@media (max-width: 960px) {
  .hero-section {
    min-height: 600px;
  }

  .hero-container {
    padding-top: 100px;
    padding-bottom: 50px;
  }

  .hero-title {
    font-size: 40px;
  }

  .hero-subtitle {
    font-size: 13px;
  }

  .hero-event-info {
    font-size: 15px;
  }

  .stat-value {
    font-size: 36px;
  }

  .stat-label {
    font-size: 13px;
  }

  .stats-section {
    gap: 32px;
  }
}

/* Mobile Landscape */
@media (max-width: 600px) {
  .hero-section {
    min-height: 500px;
  }

  .hero-container {
    padding-top: 80px;
    padding-bottom: 30px;
    padding-left: 16px;
    padding-right: 16px;
  }

  .hero-subtitle {
    font-size: 10px;
    letter-spacing: 0.8px;
    margin-bottom: 12px;
  }

  .hero-title {
    font-size: 24px;
    margin-bottom: 16px;
    line-height: 1.3;
  }

  .hero-event-info {
    font-size: 12px;
    margin-bottom: 28px;
    line-height: 1.5;
  }

  .hero-buttons {
    gap: 10px;
    margin-bottom: 35px;
    flex-direction: column;
    width: 100%;
  }

  .hero-buttons > * {
    width: 100%;
    max-width: 280px;
  }

  .stats-section {
    gap: 16px;
  }

  .stat-box {
    min-width: 70px;
  }

  .stat-value {
    font-size: 24px;
  }

  .stat-label {
    font-size: 11px;
  }
}

/* Small Mobile */
@media (max-width: 400px) {
  .hero-section {
    min-height: 480px;
  }

  .hero-container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .hero-title {
    font-size: 22px;
    line-height: 1.4;
  }

  .hero-subtitle {
    font-size: 9px;
  }

  .hero-event-info {
    font-size: 11px;
  }

  .stat-value {
    font-size: 20px;
  }

  .stat-label {
    font-size: 10px;
  }

  .stats-section {
    gap: 12px;
  }

  .stat-box {
    min-width: 65px;
  }
}
</style>
